import Box from '@mui/material/Box';
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useEffect } from 'react';
import { collectionHeaders } from '../../../constante/headers/collectionHeaders';
import { Header } from '../../../models/Header';
import { Produit } from '../../../models/Produit';
import { planoAPI, useGetStatsCollectionQuery } from '../../../redux/features/cache';
import { useAppDispatch } from '../../../redux/store';
import GridWrapper from '../../grid/GridWrapper';

export interface IStatsModalComponent {
  prod: any
}

export default function StatsModalComponent({ prod }: IStatsModalComponent) {
  const dispatch = useAppDispatch();
  let { data: stats = [] as Produit[], isSuccess } = useGetStatsCollectionQuery({ prod: prod });

  useEffect(() => {
    if (isSuccess && stats.length > 0) {
      let i = stats.map((e, i) => e.stats.primaire === true ? i : '').filter(String)
      if (i.length > 0) {
        dispatch(planoAPI.util.updateQueryData('getStatsCollection', { prod: prod }, (produit) => {
          i.forEach((e) => {
            produit[e as any].selected = produit[e as any].selected = true
            return produit
          })
        }))
      }
    }
  }, [stats])

  return (
    <div>
      <Box >
        {stats && (
          <GridWrapper>
            <Grid
              data={stats}
              rowHeight={40}
              selectedField="selected"
            >
              {collectionHeaders.map((column: Header) => (
                column.isDisplayed &&
                <GridColumn
                  key={column.field}
                  field={column.field}
                  title={column.fieldLabel}
                  format={column.fieldFormat}
                  headerClassName={`${column.fieldFormat === '{0:c}' ? 'alignRight' : ''}`}
                  className={`${column.fieldFormat === '{0:c}' ? 'alignRight' : ''}`}
                  width={150}
                />
              )
              )}
            </Grid>
          </GridWrapper>
        )}
      </Box>
    </div >
  );
}